import { createLadeskChat } from './components/ladesk.js';

// LaDesk chat button ids, one per language the support team answers in.
const CHAT_IDS = {
	default: 'cb30a715',
	fr: '08fzmnhm',
	pt: 'uin7339a',
	br: 'uin7339a',
	es: 'ktdy9k3a',
	de: '35yz43ln',
};

// Everything on the site that opens the chat: the card at the bottom of the
// screen, plus the "Contact Live Chat" calls to action spread over the landings.
const TRIGGERS = '#supportChat .content, #trigger_support_chat, .trigger_support_chat';

// Below this width the card is a permanent tab, not a card that can be dismissed.
const CARD_MIN_WIDTH = 1024;

export function supportChat () {
	const chat = createLadeskChat(CHAT_IDS[window.appLocale] || CHAT_IDS.default);

	function $card () {
		return $('#supportChat-card .supportChat-card--content');
	}

	function closeCard () {
		$card().removeClass('open').attr('aria-expanded', 'false');
		// Only the wide layout expands the card on its own, so that is the only
		// one where dismissing it is worth remembering.
		if ($(window).width() > CARD_MIN_WIDTH) {
			localStorage.setItem('support_chat_was_shown', 'true');
		}
	}

	$(document).on('click', TRIGGERS, function (e) {
		e.preventDefault();
		$card().attr('aria-expanded', 'true');
		chat.open();
	});

	// The card's trigger is a div with role="button", so it needs Enter/Space
	// wired up by hand.
	$(document).on('keydown', TRIGGERS, function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			$(this).trigger('click');
		}
	});

	$(document).on('click', '#supportChat .close', closeCard);

	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $card().hasClass('open')) {
			closeCard();
			$('#supportChat-card .content').focus();
		}
	});

	// Show the card expanded on weekdays, until the visitor dismisses it once.
	function triggerCardOpen () {
		const day = new Date().getDay();
		const isWeekend = day === 0 || day === 6;

		if ($(window).width() <= CARD_MIN_WIDTH || isWeekend) {
			return;
		}
		$card().toggleClass('open', !localStorage.getItem('support_chat_was_shown'));
	}

	triggerCardOpen();

	if (window.location.search.indexOf('init-live-help') > -1) {
		chat.open();
	}
}
